var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container channel-page"},[_c('main-menu'),_vm._v(" "),_c('main-background'),_vm._v(" "),_c('main-header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }